module.exports = __webpack_public_path__ + "static/media/grid-metro-5.3f62cd16.jpg";